import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getSite } from '../tools/fetcher';
import TestimonialSlider from './TestimonialSlider';
import { classNames } from '../tools/helpers';

export default function Testimonial({
    className,
    classNameSlider,
    innerWidth,
}) {
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    const splitTitle = useMemo(
        () => data?.testimonial?.title?.split('|') || [],
        [data],
    );

    const description =
        data?.testimonial?.description ||
        `Ini testimoni dari mereka yang sudah menggunakan layanan kami.
                Mulai dari mahasiswa hingga pekerja yang terbantu dengan layanan
                kami.`;
    return (
        <>
            <div className={className}>
                <div
                    className={classNames(
                        'grid sm:grid-cols-2 gap-10 gap-y-4 sm:gap-y-[60px]',
                        innerWidth,
                    )}
                >
                    <p
                        className={
                            'font-bold text-[32px] leading-[40px] sm:text-[40px] sm:leading-[48px]'
                        }
                    >
                        {splitTitle.length >= 1 && (
                            <span className={'text-apart-green-50'}>
                                {splitTitle[0]}
                            </span>
                        )}{' '}
                        {splitTitle.length >= 2 && splitTitle[1]}
                    </p>
                    <p
                        className={
                            'leading-[28px] text-apart-black-50 my-auto max-w-[456px] sm:ml-auto'
                        }
                    >
                        {description}
                    </p>
                </div>
            </div>
            <div className={classNameSlider}>
                <div className={classNames('mt-4 sm:mt-[60px]', innerWidth)}>
                    <TestimonialSlider />
                </div>
            </div>
        </>
    );
}
